import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllAlertFlowsQueryVariables, useAllAlertFlowsQuery } from "../../graphql"
import { AlertFlowsList } from "./AlertFlowsList"

export const AllAlertFlows: React.FC = () => {
	const [pagination, setPagination] = useState<AllAlertFlowsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllAlertFlowsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allAlertFlows.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allAlertFlows ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading alert flows</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allAlertFlows.alertFlows && data.allAlertFlows.alertFlows.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allAlertFlows.alertFlows.length || 0} alert flow
						{(data.allAlertFlows.alertFlows.length || 0) > 1 ? "s" : ""}
					</Text>

					<AlertFlowsList alertFlows={data.allAlertFlows.alertFlows} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more alert flows</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any alert flows.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
